export const mapScheduleToEvent = (schedule) => {
  const {
    id,
    start_date,
    end_date,
    name,
    description,
    flow_id,
    repeat_type,
    status,
    repetition,
    created_by_id,
    updated_date_time,
    created_date_time,
    documentation,
    tenant_id,
    notes,
  } = schedule;

  return {
    repetition,
    id,
    description,
    status,
    flowId: flow_id,
    title: name,
    start: start_date,
    end: end_date,
    repeat: repeat_type,
    className: status || (repeat_type === "not_repeat" ? "Active" : "Recurring"),
    created_by_id,
    updated_date_time,
    created_date_time,
    documentation,
    tenant_id,
    notes,
  };
};
